import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import FormAlumno from '../forms/form_alumno';
import { updateEstudiante } from '../actions';

class DetalleEstudiante extends Component {
  constructor(props){
      super(props);

      this.state = {
        redirect: ""
      };

      this.submitForm = this.submitForm.bind(this);
  }

  submitForm(data){
    this.props.updateEstudiante(this.props.usuario.id, data);
    this.setState({ redirect: "/" });
  }

  render(){

    if(this.state.redirect !== ""){
      return <Redirect to={this.state.redirect} />;
    }
    if (this.props.usuario===null) {
      return(
        <section id="form-alumno">
          <div className="container">
            <h1>Cargando...</h1>
          </div>
        </section>
      );
    }
    return (
      <section id="form-alumno">
        <div className="container">
          <h1>Modificar Usuario</h1>
          <hr />
          <FormAlumno submitText="Guardar"
            submit={this.submitForm}
            data={this.props.usuario} />
        </div>
      </section>
    );
  }
}

function mapStateToProps({ usuario }) {
  return { usuario };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateEstudiante
  }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(DetalleEstudiante);



// WEBPACK FOOTER //
// ./src/containers/detalle_usuario.js